module.exports = __webpack_public_path__ + "media/assets/faria_products/CT-TL-aa6367fddd9783b72d9096113420288f166d1238b3cb5ec743d8b991d871c597.png";